import React from 'react'
import { HowItWorks } from './HowItWorks'
import { WhyChoseLegalUtopiaPortal } from './WhyChoseLegalUtopiaPortal'

export const TabBottom = (props: {
  className: string
  data: Array<{ title: string; content: string }>
}) => (
  <div className='flex flex-col lg:flex-row justify-between lg:justify-center gap-20 items-center w-full'>
    <HowItWorks data={props.data} />
    <WhyChoseLegalUtopiaPortal className={props.className} />
  </div>
)
